import { render, staticRenderFns } from "./SideSteps.vue?vue&type=template&id=2cc3426c&scoped=true&"
import script from "./SideSteps.vue?vue&type=script&lang=js&"
export * from "./SideSteps.vue?vue&type=script&lang=js&"
import style0 from "./SideSteps.vue?vue&type=style&index=0&id=2cc3426c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3426c",
  null
  
)

/* custom blocks */
import block0 from "./SideSteps.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports